import { Rectangle } from './rectangle';

export class RatioUtil {

  constructor() {
    
  }

  /**
		*	Determines the ratio of width to height.
		*/
  static widthToHeight(size: Rectangle): number {
    return size.width / size.height;
  }

  /**
   *	Determines the ratio of height to width.
   */
  static heightToWidth(size: Rectangle): number {
    return size.height / size.width;
  }

  /**
   * Scales an area's width and height while preserving aspect ratio.
   */
  static scale(size: Rectangle, amount: number): Rectangle {
    var scaled: Rectangle = size.clone();

    scaled.width *= amount;
    scaled.height *= amount;

    return scaled;
  }

  /**
   *	Scales the width of an area while preserving aspect ratio.
   */
  static scaleWidth(size: Rectangle, height: number): Rectangle {
    var scaled: Rectangle = size.clone();
    var ratio: number = RatioUtil.widthToHeight(size);

    scaled.width = height * ratio;
    scaled.height = height;

    return scaled;
  }

  /**
   *	Scales the height of an area while preserving aspect ratio.
   */
  static scaleHeight(size: Rectangle, width: number): Rectangle {
    var scaled: Rectangle = size.clone();
    var ratio: number = RatioUtil.heightToWidth(size);

    scaled.width = width;
    scaled.height = width * ratio;

    return scaled;
  }

  /**
   *	Resizes an area to fill the bounding area while preserving aspect ratio.
   */
  static scaleToFill(size: Rectangle, bounds: Rectangle): Rectangle {
    var scaled: Rectangle = RatioUtil.scaleHeight(size, bounds.width);

    if (scaled.height < bounds.height)
      scaled = RatioUtil.scaleWidth(size, bounds.height);

    return scaled;
  }

  /**
   *	Resizes an area to the maximum size of a bounding area without exceeding while preserving aspect ratio.
   */
  static scaleToFit(size: Rectangle, bounds: Rectangle): Rectangle {
    var scaled: Rectangle = RatioUtil.scaleHeight(size, bounds.width);

    if (scaled.height > bounds.height)
      scaled = RatioUtil.scaleWidth(size, bounds.height);

    return scaled;
  }
}
